import React, { Component } from 'react';
import styled from 'styled-components';

import SegmentMenu from './shared/SegmentMenu';
import SegmentButton from './shared/SegmentMenu';
import ProductTitle from './shared/ProductTitle';
import Checkbox from './shared/Checkbox';
import Chooser from './shared/Chooser';
import ProductStage from './shared/ProductStage';
import Text from './shared/Text';
import Price from './shared/Price';
import Button from './shared/Button';
import Dialog from './shared/Dialog';

import {
    getPossibleAttributesFor,
    getProductImages,
    getPossibilitiesFor,
    getImpossibleAttributesFor,
    mapSelectedVariationToProperties,
    mapPropertiesToSelectedVariation,
} from '../utils/configUtils';

import { sendToCart, getPropertiesFromCart } from '../utils/shopify';

const MEDIA = '(min-width: 48em)';

const View = styled.div`
    width: 100%;
`;

const ProductGrid = styled.div`
    margin-top: 24px;
    display: flex;
    flex-direction: column;
    text-align: center;

    @media ${MEDIA} {
        margin-top: 48px;
        flex-direction: row;
        text-align: left;
    }
`;

const TitleCol = styled.div`
    order: 1;

    @media ${MEDIA} {
        width: 224px;
        padding-right: 24px;
        order: unset;
    }
`;

const MainCol = styled.div`
    position: relative;
    margin-bottom: 24px;
    flex: 1;
    order: 0;

    @media ${MEDIA} {
        margin-bottom: 0;
        order: unset;
    }
`;

const ChooserCol = styled.div`
    margin-top: 24px;
    margin-bottom: 24px;
    position: relative;
    z-index: 1;
    order: 2;

    @media ${MEDIA} {
        margin-top: 0;
        margin-bottom: 0;
        width: 124px;
        padding-left: 24px;
        order: unset;
    }
`;

const ImpossibeItems = styled.div`
    margin-top: 42px;
`;

const ImpossibeItemsTitle = styled.p`
    font-size: 11px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 1px;
`;

const CheckboxWithSpace = styled(Checkbox)`
    margin-bottom: 12px;
`;

const StyledProductTitle = styled(ProductTitle)`
    margin-bottom: 24px;

    @media ${MEDIA} {
        margin-bottom: 48px;
    }
`;

const StyledText = styled(Text)`
    margin-bottom: 24px;

    @media ${MEDIA} {
        margin-bottom: 48px;
    }
`;

const StyledPrice = styled(Price)`
    margin-bottom: 24px;
    display: ${(props) => (props.showOnMobile ? 'inline-block' : 'none')};

    @media ${MEDIA} {
        display: ${(props) => (props.showOnMobile ? 'none' : 'inline-block')};
        margin-bottom: 48px;
    }
`;

const ActionTop = styled.div`
    display: none;

    @media ${MEDIA} {
        display: block;
    }
`;

const ActionBottom = styled.div`
    order: 3;
    margin-bottom: 24px;

    @media ${MEDIA} {
        display: none;
        order: unset;
    }
`;

const PagerContainer = styled.div`
    @media ${MEDIA} {
        margin-top: 20px;
        margin-bottom: 20px;
        text-align: center;
    }
`;

const PagerButton = styled.button`
    width: 50px;
    height: 50px;
    padding: 0;
    border: 1px solid #4a4a4a;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    left: ${(props) => (props.left ? 0 : 'auto')};
    right: ${(props) => (props.right ? 0 : 'auto')};
    z-index: 1;
    transform: translateY(-50%);
    background-color: rgba(255, 255, 255, 0.75);
    cursor: pointer;

    &:focus {
        outline: none;
        border-color: #000;
    }

    @media ${MEDIA} {
        width: 75px;
        height: 75px;
        margin-left: 40px;
        position: static;
        transform: none;

        &:hover {
            opacity: 0.7;
        }

        &:active {
            transform: scale(0.98);
        }
    }
`;

const SegmentTitle = styled.div`
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 1px;
    color: ${(props) => props.color};

    @media ${MEDIA} {
        display: none;
    }
`;

const getVariation = (selection) => {
    const { sockTop, strapMaterial } = selection;
    let variation = {
        price: '189,-',
        variationId: 1976516083756,
    };

    if (sockTop !== 'none')
        variation = {
            price: '198,-',
            variationId: 1976663474220,
        };

    if (strapMaterial === 'swarovski')
        variation = {
            price: '279,-',
            variationId: 1976663506988,
        };

    if (strapMaterial === 'swarovski' && sockTop !== 'none')
        variation = {
            price: '289,-',
            variationId: 1976663539756,
        };

    return variation;
};

class Desktop extends Component {
    state = {
        selectedMenuIndex: 0,
        selectedVariation: null,
        changeDialog: null,
    };

    componentDidMount() {
        const { variationId } = this.props;

        if (variationId) {
            getPropertiesFromCart(variationId).then((properties) => {
                const selectedVariationFromCart =
                    mapPropertiesToSelectedVariation(
                        properties,
                        this.props.config
                    );

                this.setState({
                    selectedVariation: selectedVariationFromCart,
                });
            });
        } else {
            this.setState({
                selectedVariation: this.props.config.initialSelected,
            });
        }
    }

    render() {
        if (!this.state.selectedVariation) return null;

        return (
            <View>
                {this.renderMenu()}

                <div>{this.renderPage()}</div>

                <Dialog
                    open={this.state.changeDialog !== null}
                    title="Änderung der Auswahl"
                    secondaryAction={{
                        label: 'Lieber nicht ...',
                        onClick: () => this.setState({ changeDialog: null }),
                    }}
                    primaryAction={{
                        label: 'Ja, ändern',
                        onClick: () =>
                            this.setState({
                                changeDialog: null,
                                selectedVariation:
                                    this.state.changeDialog.nextPossible,
                            }),
                    }}
                >
                    {this.renderChangeDialogContent()}
                </Dialog>
            </View>
        );
    }

    renderMenu() {
        const { segments } = this.props.config;
        const { selectedMenuIndex, selectedVariation } = this.state;

        if (this.props.isMobile) return null;

        return (
            <SegmentMenu
                selectedIndex={selectedMenuIndex}
                onClickItem={this.handleMenuClick}
            >
                {segments.map((segment, i) => {
                    const key = selectedVariation[segment.name] || '';

                    const attrs =
                        this.props.config[segment.name] && key
                            ? this.props.config[segment.name][key]
                            : {
                                  title: '-',
                              };

                    return (
                        <SegmentButton
                            key={segment.name}
                            iconUrl={segment.iconSrc}
                            title={segment.title}
                            subtitle={attrs.label}
                            batchColor={attrs.color}
                        />
                    );
                })}
            </SegmentMenu>
        );
    }

    renderPage() {
        const { segments, useColorFrom } = this.props.config;
        const { selectedMenuIndex, selectedVariation } = this.state;

        const segment = segments[selectedMenuIndex];

        if (!this.props.config[segment.name]) return null;

        const item =
            this.props.config[segment.name][selectedVariation[segment.name]];

        const possibleItems = getPossibleAttributesFor(
            segment.name,
            this.props.config,
            selectedVariation
        );

        const impossibeItems = getImpossibleAttributesFor(
            segment.name,
            this.props.config,
            selectedVariation
        );

        const colorId = selectedVariation[useColorFrom[segment.name]];
        const color = this.props.config[useColorFrom[segment.name]][colorId];

        const variation = getVariation(selectedVariation);

        const isIE = document.body.style.msTouchAction !== undefined;

        return (
            <ProductGrid>
                <TitleCol>
                    <SegmentTitle color={color.contrast || color.color}>
                        {segment.title}
                    </SegmentTitle>

                    <StyledProductTitle
                        color={color.contrast || color.color}
                        size={this.props.isMobile ? 'small' : 'normal'}
                    >
                        {item.title || ''}
                    </StyledProductTitle>

                    {item.description && (
                        <StyledText>{item.description || ''}</StyledText>
                    )}

                    <StyledPrice
                        additional={() => {
                            return (
                                <span>
                                    Preis inkl. MwSt. zzgl.{' '}
                                    <a
                                        target="_blank"
                                        href="/pages/zahlung-und-versand"
                                    >
                                        Versandkosten
                                    </a>
                                </span>
                            );
                        }}
                    >
                        {variation.price}
                    </StyledPrice>

                    <ActionTop>
                        <Button
                            label="In den Warenkorb"
                            onClick={this.handleAddToCart}
                        />
                    </ActionTop>
                </TitleCol>

                <MainCol>
                    <ProductStage
                        size={this.props.isMobile ? '80vw' : '60vw'}
                        color={color.color}
                        imageSrc={color.imageSrc}
                        productImages={getProductImages(
                            this.props.config,
                            selectedVariation
                        )}
                    />

                    <PagerContainer>
                        <PagerButton left onClick={this.handlePagerLeftClick}>
                            <svg
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z" />
                            </svg>
                        </PagerButton>

                        <PagerButton right onClick={this.handlePagerRightClick}>
                            <svg
                                fill="#000000"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z" />
                            </svg>
                        </PagerButton>
                    </PagerContainer>
                </MainCol>

                <ChooserCol
                    style={{
                        marginTop: isIE ? 72 : 0,
                    }}
                >
                    {this.renderChooser(segment, possibleItems)}

                    {Object.keys(impossibeItems).length > 0 && (
                        <ImpossibeItems>
                            <ImpossibeItemsTitle>
                                Varianten in andereren Kombinationen
                            </ImpossibeItemsTitle>
                            {this.renderChooser(segment, impossibeItems)}
                        </ImpossibeItems>
                    )}
                </ChooserCol>

                <ActionBottom>
                    <StyledPrice
                        showOnMobile
                        additional={() => {
                            return (
                                <span>
                                    Preis inkl. MwSt. zzgl.{' '}
                                    <a
                                        target="_blank"
                                        href="/pages/zahlung-und-versand"
                                    >
                                        Versandkosten
                                    </a>
                                </span>
                            );
                        }}
                    >
                        {variation.price}
                    </StyledPrice>
                    <div />
                    <Button
                        label="In den Warenkorb"
                        onClick={this.handleAddToCart}
                    />
                </ActionBottom>
            </ProductGrid>
        );
    }

    renderChooser(segment, segmentItems) {
        const { selectionTypes } = this.props.config;
        const { selectedVariation } = this.state;

        switch (selectionTypes[segment.name]) {
            case 'checkbox':
                return Object.keys(segmentItems).map((key) => {
                    const item = segmentItems[key] || {};

                    return (
                        <CheckboxWithSpace
                            key={key}
                            imageSrc={item.iconSrc}
                            label={item.label}
                            name={key}
                            onClick={(value) =>
                                this.handleCheckboxChange(segment.name, value)
                            }
                            checked={key === selectedVariation[segment.name]}
                        />
                    );
                });

            case 'color':
                const items = Object.keys(segmentItems).map((key) => {
                    const item = segmentItems[key] || {};
                    return {
                        color: item.color,
                        imageSrc: item.imageSrc,
                        contrast: item.contrast,
                    };
                });

                const selectedIndex = Object.keys(segmentItems).reduce(
                    (index, key, i) => {
                        if (key === selectedVariation[segment.name]) return i;

                        return index;
                    },
                    -1
                );

                return (
                    <Chooser
                        items={items}
                        selectedIndex={selectedIndex}
                        onChoose={(index) => {
                            this.handleCheckboxChange(
                                segment.name,
                                Object.keys(segmentItems)[index]
                            );
                        }}
                    />
                );

            default:
                return null;
        }
    }

    getItemsToChange(deps, possibilities, selectedVariation) {
        return deps.reduce((acc, key) => {
            const wannaBe = possibilities.nextPossible[key];
            const selected = selectedVariation[key];

            if (wannaBe !== selected)
                return [...acc, { segment: key, value: wannaBe }];

            return acc;
        }, []);
    }

    renderChangeDialogContent() {
        const { changeDialog, selectedVariation } = this.state;
        const { dependencies, segments } = this.props.config;

        if (!changeDialog) return null;
        const deps = dependencies[changeDialog.for.segmentName];

        const itemsToChange = this.getItemsToChange(
            deps,
            changeDialog,
            selectedVariation
        );

        const Change = (props) => {
            return (
                <div>
                    <b>{props.segment}</b>: {props.value}
                </div>
            );
        };

        return (
            <div>
                <p>
                    Diese Auswahl ist mit Deiner bisherigen Kombi so leider
                    nicht möglich. Wir müssten folgende Dinge ändern, um mit
                    Deiner Auswahl weitermachen zu können:
                </p>
                {itemsToChange.map((item) => {
                    const segment =
                        segments.find((s) => s.name === item.segment) || {};

                    const segmentItem =
                        this.props.config[segment.name][item.value] || {};

                    return (
                        <Change
                            key={item.segment}
                            segment={segment.title}
                            value={segmentItem.label}
                        />
                    );
                })}
            </div>
        );
    }

    handleCheckboxChange = (segmentName, value) => {
        const possibleItems = Object.keys(
            getPossibleAttributesFor(segmentName, this.props.config, {
                ...this.state.selectedVariation,
                [segmentName]: value,
            })
        );

        if (possibleItems.indexOf(value) > -1) {
            this.setState({
                selectedVariation: {
                    ...this.state.selectedVariation,
                    [segmentName]: value,
                },
            });
        } else {
            const nextPossible = getPossibilitiesFor(
                {
                    [segmentName]: value,
                },
                this.props.config,
                this.state.selectedVariation
            );

            const itemsToChange = this.getItemsToChange(
                this.props.config.dependencies[segmentName],
                { nextPossible },
                this.state.selectedVariation
            ).filter((item) => {
                const index = this.props.config.segments.findIndex(
                    (seg) => seg.name === item.segment
                );

                return index < this.state.selectedMenuIndex;
            });

            if (itemsToChange.length > 0) {
                this.setState({
                    changeDialog: {
                        for: {
                            segmentName,
                            value,
                        },
                        nextPossible,
                    },
                });
            } else {
                this.setState({
                    selectedVariation: {
                        ...this.state.selectedVariation,
                        ...nextPossible,
                    },
                });
            }
        }
    };

    handleMenuClick = (index) => {
        this.setState({
            selectedMenuIndex: index,
        });
    };

    handlePagerRightClick = () => {
        const { selectedMenuIndex } = this.state;
        const { segments } = this.props.config;

        let nextIndex = selectedMenuIndex + 1;

        if (segments.length === nextIndex) {
            nextIndex = 0;
        }

        this.setState({
            selectedMenuIndex: nextIndex,
        });
    };

    handlePagerLeftClick = () => {
        const { selectedMenuIndex } = this.state;
        const { segments } = this.props.config;

        let nextIndex = selectedMenuIndex - 1;

        if (nextIndex < 0) {
            nextIndex = segments.length - 1;
        }

        this.setState({
            selectedMenuIndex: nextIndex,
        });
    };

    handleAddToCart = () => {
        const propertiesForShopify = mapSelectedVariationToProperties(
            this.state.selectedVariation,
            this.props.config
        );

        const { variationId } = getVariation(this.state.selectedVariation);

        sendToCart(propertiesForShopify, variationId)
            .then(() => {
                window.location.href = '/cart';
            })
            .catch((e) => console.error(e));
    };
}

export default Desktop;



// WEBPACK FOOTER //
// ./src/components/Desktop.js